/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Parties_Delete_ConfirmInputs */

const cs_parties_delete_confirm = /** @type {(inputs: Parties_Delete_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Smazat stranu „${i?.name}“?`)
};

const en_parties_delete_confirm = /** @type {(inputs: Parties_Delete_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Delete party “${i?.name}”?`)
};

/**
* | output |
* | --- |
* | "Delete party “{name}”?" |
*
* @param {Parties_Delete_ConfirmInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const parties_delete_confirm = /** @type {((inputs: Parties_Delete_ConfirmInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Parties_Delete_ConfirmInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_parties_delete_confirm(inputs)
	return cs_parties_delete_confirm(inputs)
});